import * as React from "react";

export interface DotPaginationProps {
  className?: string;
  pagesCount?: number;
  currentIndex?: number;
  onPageSelect?: (idx: number) => void;
}

export interface DotPaginationState {}

export class DotPagination extends React.Component<
  DotPaginationProps,
  DotPaginationState
> {
  el: HTMLDivElement;
  constructor(p: DotPaginationProps) {
    super(p);
  }

  constructDots = (length, selected) => {
    const dots = [];

    for (let i = 0; i < length; i++) {
      dots.push({ index: i, selected: i <= selected });
    }

    return dots;
  };

  render() {
      
    const dots = this.constructDots(
      this.props.pagesCount,
      this.props.currentIndex
    );

    return (
      <div className={this.props.pagesCount < 2 ? "dot-pagination-container hidden-pagination" :  "dot-pagination-container"}>
        {dots.map(dot => (
          <span
            key={dot.index}
            onClick={() => this.props.onPageSelect(dot.index)}
            className={dot.selected ? "selected dot" : "dot"}
          />
        ))}
      </div>
    );
  }
}
